import { render, staticRenderFns } from "./btn_share.mpx?vue&type=template&id=355647c9&scoped=true&component=true&componentId=btn_share0d755e87"
import script from "./btn_share.mpx?vue&type=script&lang=js&component=true&componentId=btn_share0d755e87"
export * from "./btn_share.mpx?vue&type=script&lang=js&component=true&componentId=btn_share0d755e87"
import style0 from "./btn_share.mpx?vue&type=style&index=0&id=355647c9&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m0d755e87%22%7D&component=true&componentId=btn_share0d755e87"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355647c9",
  null
  
)

export default component.exports